import { themeVars } from '../themeVars.css';
import { style } from '@vanilla-extract/css';

export const darkTooltipClass = style({
  backgroundColor: `${themeVars.colors.neutrals.black100}!important`,
  color: `${themeVars.colors.neutrals.white}!important`,
});
